module.exports = __webpack_public_path__ + "static/media/ic_head13.84f46c54.png";